module.exports = __webpack_public_path__ + "./Jenny_second_34c23760133af87f01c0ca8067592aa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Jenny_second.jpg
// module id = 562
// module chunks = 0